/*global jQuery */
(function($) {
	
	jQuery('li.nav-item').hover(function() {
	    jQuery(this).find('.dropdown-menu').addClass('show');
	  }, function() {
	    jQuery(this).find('.dropdown-menu').removeClass('show');
	});


	$(function() {

		$('.back-button').on('click', function() {
	    history.go(-1);
	  });
		var moveto = 45;
	  if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
	      //$('.bg_banner_hp, .menu2').css('margin-top', '0').css('top', '0');
	      //$('#content').css('margin-top', '130px')
	      moveto=45;
	  }

		var lastScrollTop = 0;
		var moving = false;
	  $(window).scroll(function(event){
	     var st = $(this).scrollTop();
	     if (st > lastScrollTop){
	        // downscroll code
	        if (st>1 && !$('.menu2').is(':visible') ) $('.menu2').fadeIn();
         	if (st>45 && !moving) {
         		
         		moving = true;
         		$('#header .movetop').animate({top:0}, 400, function() { moving = false;});
         		//console.log('45')
         	}



	     } else {
	        // upscroll code
	        if (!moving) {
	        	moving = true;
	        	$('#header .movetop').animate({top:moveto}, 400, function() { moving = false; });
	        	//console.log('scroll up')
	        }
			     if (st<150 && window.isHome ) {
		       		$('.menu2').fadeOut();
		       }
	     }


	     lastScrollTop = st;
	  });

  });

}(jQuery));
